import script from "./NewShowingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewShowingForm.vue?vue&type=script&setup=true&lang=js"

import "./NewShowingForm.vue?vue&type=style&index=0&id=33423964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33423964"]])

export default __exports__